<template>
<div class="block">
  <el-timeline>
    <el-timeline-item v-for="item in logList" :key="item.dateTime" :timestamp=item.dateTime placement="top" :color="item.color">
      <el-card>
        <h4>{{item.title}}</h4>
        <p>{{item.content}}</p>
      </el-card>
    </el-timeline-item>
  </el-timeline>
</div>
  </template>
<script>
export default {
  name: 'Blogs',
  data () {
    return {
      logList: [{
        dateTime: '2023-01-01',
        title: 'html',
        content: '学会了html的标签的使用',
        color: '#0bbd87'
      }, {
        dateTime: '2023-02-01',
        title: 'css样式的基础使用',
        content: '学会了基础布局，并且掌握了样式的基础使用',
        color: 'red'
      }, {
        dateTime: '2023-03-01',
        title: 'javascript',
        content: '学会了javascript的基础使用',
        color: '#0bbd87'
      }, {
        dateTime: '2023-04-01',
        title: 'Vue基础使用',
        content: '学会了使用脚手架创建vue项目，并且掌握路由的用法',
        color: 'red'
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Logs/index.vue